<template>
    <div class="buy-now-playlist">
        <h3>Congrats!<br>It’s off to the roaster.</h3>
        <div class="pug-img-wrapper">
            <transition name="fade">
                <img v-show="imgLoaded" class="pug-img" src="~home/buy-now/pug.png" alt="Pug" v-on:load="imgLoaded = true">
            </transition>
        </div>

        <template v-if="!firstTimeToActivePlaylist">
            <template v-if="playlistData.paused">
                <!-- Playlist paused temporary -->
                <div v-if="playlistData.resumeAt">
                    <p class="font-lg">Just a reminder, your brew queue is paused until</p>
                    <p class="font-lg"><strong>{{ formatDate(playlistData.resumeAt) }}</strong></p>
                    <p class="margin-top-md">If you need coffee sooner you can unpause any time.</p>
                    <button class="btn-green-lg buy-now-playlist-btn" @click="reloadAndOpenPlaylist()">Go to my brew queue</button>
                </div>
                <!-- Playlist paused indefinitely -->
                <div v-else>
                    <p class="font-lg">Just a reminder, your brew queue is paused.</p>
                    <button class="btn-green-lg buy-now-playlist-btn" @click="reloadAndOpenPlaylist()">Edit Subscription Settings</button>
                </div>
            </template>

            <!-- Playlist is NOT paused -->
            <div v-else class="next-playlist-order">
                <p class="font-lg">Just a reminder, your brew queue is running and your next order is scheduled for:</p>
                <p class="font-lg"><strong>{{ formatDate(playlistData.nextRunAt) }}</strong></p>
                <p v-if="playlistData.firstItem" class="next-playlist-coffee">{{ playlistData.firstItem.productName }} ({{ playlistData.firstItem.sellerName }})</p>
                <button class="btn-green-lg buy-now-playlist-btn" @click="reloadAndOpenPlaylist()">
                    <div v-if="loading" class="spinner">
                        &nbsp
                    </div>
                    <span v-else>
                        Go to my brew queue
                    </span>
                </button>
            </div>
        </template>

        <!-- If they are haven't activated playlist -->
        <div v-else>
            <h3>Get Coffee on the Reg</h3>
            <div class="playlist-note">
                <p>1) Add coffees to your brew queue</p>
                <p>2) Choose how often you want deliveries</p>
                <p>3) Rate your coffees as they arrive</p>
            </div>
            <p><strong>Never pay for shipping again!</strong></p>
            <button class="btn-green-lg buy-now-playlist-btn margin-top-md" @click="$emit('activate')">Let's get this puppy started!</button>
        </div>
    </div>
</template>

<script>
    import DateMixin from "../../../mixins/date-mixin";
    // Images
    import "home/buy-now/pug.png";

    export default {
        mixins: [
            DateMixin
        ],
        props: {
            playlistData: Object,
            currentUrl: String,
            firstTimeToActivePlaylist: Boolean
        },
        data: function() {
            return {
                imgLoaded: false,
                loading: false
            }
        },
        methods: {
            reloadAndOpenPlaylist() {
                this.loading = true;
                const urlParam = this.currentUrl.includes('?') ? '&open_playlist=true' : '?open_playlist=true';
                window.location.replace(this.currentUrl + urlParam);
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../styles/_variables_home.scss";
    @import "../../../styles/common_home.scss";

    .buy-now-playlist {
        text-align: center;
        padding: 2rem;
        h3 {
            font-size: 24px;
            font-weight: bold;
            color: $color-primary;
        }
    }
    .next-playlist-order {
        line-height: normal;
        h3 {
            margin-bottom: 2rem;
        }
        .next-playlist-coffee {
           margin-bottom: 1rem;
        }
    }
    .pug-img-wrapper {
        width: 200px;
        height: 200px;
        margin: auto;
    }
    .pug-img {
        width: 100%;
        height: 100%;
    }
    .buy-now-playlist-btn {
        margin-top: 1rem;
    }
    .playlist-note {
        margin: 1.5rem 0;
        p {
            margin: 0.25rem;
        }
    }
</style>
